import { APP_MODULES } from './appModules';
import { EDDR_MODULES } from './eddrModules';
import { LESSONS_LEARNT_MODULES } from './lessonsLearntModule';
import { USER_ADMIN_MODULES } from './userAdminModules';

export const MODULE_ROOT_PATHS = {
  // DRILLX SMART OPERATIONS
  [APP_MODULES.HOME]: '/',
  [APP_MODULES.DRILLX_COCKPIT]: '/drillx-map',
  [APP_MODULES.EDDR]: '/eDDR',
  [APP_MODULES.LESSONS_LEARNT]: '/lessons-learnt',
  [APP_MODULES.USER_ADMIN]: '/user-admin',
  [APP_MODULES.WELL_GROUPS]: '/user-admin',
  [APP_MODULES.ADMIN_PO]: '/admin-po',
  [APP_MODULES.GLOBAL_FEEDBACK]: `/global-feedback`,
} as const;

export const EDDR_MODULE_ROOT_PATHS = {
  [EDDR_MODULES.EDDR_OVERVIEW]: '/overview',
  [EDDR_MODULES.EDDR_OPERATIONS_LOG]: '/operations-log',
  [EDDR_MODULES.EDDR_FLUIDS]: '/fluids',
  [EDDR_MODULES.EDDR_SAFETY]: '/safety',
  [EDDR_MODULES.EDDR_TRAJECTORY]: '/trajectory',
  [EDDR_MODULES.EDDR_BHA]: '/bha',
  [EDDR_MODULES.EDDR_WELL_ACTIVITY_HISTORY]: '/wellActivityHistory',
} as const;

export const LESSONS_LEARNT_MODULE_ROOT_PATHS = {
  [LESSONS_LEARNT_MODULES.LESSONS_LEARNT_REGISTER]: '/register',
  [LESSONS_LEARNT_MODULES.LESSONS_LEARNT_WELL]: '/well',
  [LESSONS_LEARNT_MODULES.LESSONS_LEARNT_VIEW]: '/view',
} as const;

export const USER_ADMIN_MODULE_ROOT_PATHS = {
  [USER_ADMIN_MODULES.USER_ADMIN]: '/',
  [USER_ADMIN_MODULES.WELL_GROUPS]: '/well-groups',
} as const;

const DRILLX_SMART_OPERATIONS_PATHS = {
  HOME: `/`,
  WELLS: `/wells`,
  DRILLX_COCKPIT: `${MODULE_ROOT_PATHS.DRILLX_COCKPIT}`,
  EDDR_OVERVIEW: `${MODULE_ROOT_PATHS.EDDR}${EDDR_MODULE_ROOT_PATHS.EDDR_OVERVIEW}/:tuwi`,
  EDDR_OPERATIONS_LOG: `${MODULE_ROOT_PATHS.EDDR}${EDDR_MODULE_ROOT_PATHS.EDDR_OPERATIONS_LOG}/:tuwi`,
  EDDR_FLUIDS: `${MODULE_ROOT_PATHS.EDDR}${EDDR_MODULE_ROOT_PATHS.EDDR_FLUIDS}/:tuwi`,
  EDDR_SAFETY: `${MODULE_ROOT_PATHS.EDDR}${EDDR_MODULE_ROOT_PATHS.EDDR_SAFETY}/:tuwi`,
  EDDR_TRAJECTORY: `${MODULE_ROOT_PATHS.EDDR}${EDDR_MODULE_ROOT_PATHS.EDDR_TRAJECTORY}/:tuwi`,
  EDDR_BHA: `${MODULE_ROOT_PATHS.EDDR}${EDDR_MODULE_ROOT_PATHS.EDDR_BHA}/:tuwi`,
  EDDR_WELL_ACTIVITY_HISTORY: `${MODULE_ROOT_PATHS.EDDR}${EDDR_MODULE_ROOT_PATHS.EDDR_WELL_ACTIVITY_HISTORY}/:tuwi`,

  LESSONS_LEARNT_REGISTER: `${MODULE_ROOT_PATHS.LESSONS_LEARNT}${LESSONS_LEARNT_MODULE_ROOT_PATHS.LESSONS_LEARNT_REGISTER}`,
  LESSONS_LEARNT_WELL: `${MODULE_ROOT_PATHS.LESSONS_LEARNT}${LESSONS_LEARNT_MODULE_ROOT_PATHS.LESSONS_LEARNT_WELL}`,
  LESSONS_LEARNT_VIEW: `${MODULE_ROOT_PATHS.LESSONS_LEARNT}${LESSONS_LEARNT_MODULE_ROOT_PATHS.LESSONS_LEARNT_VIEW}/:lessonLearntId`,
  USER_ADMIN: `${MODULE_ROOT_PATHS.USER_ADMIN}${USER_ADMIN_MODULE_ROOT_PATHS.USER_ADMIN}`,
  WELL_GROUPS: `${MODULE_ROOT_PATHS.USER_ADMIN}${USER_ADMIN_MODULE_ROOT_PATHS.WELL_GROUPS}`,
  GLOBAL_FEEDBACK: `/global-feedback`,

  ADMIN_PO: `${MODULE_ROOT_PATHS.ADMIN_PO}`,
} as const;

export const PATHS = {
  ...DRILLX_SMART_OPERATIONS_PATHS,
};

export type PATH = (typeof PATHS)[keyof typeof PATHS];

export const NOT_WELL_RELATED_PATHS = [
  DRILLX_SMART_OPERATIONS_PATHS.HOME,
  DRILLX_SMART_OPERATIONS_PATHS.GLOBAL_FEEDBACK,
  DRILLX_SMART_OPERATIONS_PATHS.DRILLX_COCKPIT,

  DRILLX_SMART_OPERATIONS_PATHS.USER_ADMIN,
  DRILLX_SMART_OPERATIONS_PATHS.WELL_GROUPS,
  DRILLX_SMART_OPERATIONS_PATHS.LESSONS_LEARNT_REGISTER,
  DRILLX_SMART_OPERATIONS_PATHS.ADMIN_PO,
] as const;
